export class Converter {
    stringToFloat(value: string, separator: string = ','): number {
        return value.length > 1 ? parseFloat(value.split(separator).join('')) : parseFloat(value);
    }
}